import React from 'react';
import { PageProps, Link } from 'gatsby';
import { INovelData } from '@/@types/interface';
import styles from './style.module.scss';

interface ISanGuoYanYiPageContextProps {
  novelData: INovelData;
}

export const SanGuoYanYi: React.FC<PageProps<{}, ISanGuoYanYiPageContextProps>> = ({ pageContext: { novelData } }) => {
  return (
    <div className={styles.sanguoHome}>
      <div className="headerContainer">
        <header className="header">
          <img src={require('../../../assets/logo.svg')} />
        </header>
        <div className="novelInfo">
          <div className="cover" />
          <div className="introduce">
            <h1 className="novelName">
              三国演义<span>罗贯中原著</span>
            </h1>
            <p className="desciption">
              《三国演义》又名《三国志演义》、《三国志通俗演义》，是我国小说史上最著名最杰出的长篇章回体历史小说。
              《三国演义》的作者是元末明初人罗贯中，在其成书前，“三国故事”已经历了数百年的历史发展过程。在唐代，三国故事已广为流传，连儿童都很熟悉。随着市民
              文艺的发展，宋代的“说话”艺人，已有专门说三国故事的，当时称为“说三分”。元代出现的《三国志平话》，实际上是从说书人使用的本子，虽较简略粗糙，但
              已初肯《三国演义》的规模
            </p>
          </div>
        </div>
      </div>
      <nav>
        <div className="chapterNavigatorInner">
          <h3 className="catalog">
            目录<span>（共 {Object.keys(novelData).length} 章）</span>
          </h3>
          <ul className="catalogContainer">
            {Object.keys(novelData).map((key) => {
              const { title } = novelData[key];
              const reg = /^第(.*?)回/;
              const noNameTitle = title.replace('《三国演义》', '');
              const cleanTitle = noNameTitle.replace(reg, '').trim();
              const index = noNameTitle.match(reg);
              return (
                <li title={cleanTitle} key={cleanTitle}>
                  <Link to={`/san-guo-yan-yi/${key}`}>
                    <span className="index">{index && index[0]}</span>
                    <span className="title">{cleanTitle}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </nav>
    </div>
  );
};
